"use strict";

var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }

  return cooked;
};

var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  var desc = Object.getOwnPropertyDescriptor(m, k);

  if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
    desc = {
      enumerable: true,
      get: function get() {
        return m[k];
      }
    };
  }

  Object.defineProperty(o, k2, desc);
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});

var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});

var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) {
    if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  }

  __setModuleDefault(result, mod);

  return result;
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.InputFieldContainer = exports.ToggleableInputFieldContainer = exports.Input = void 0;

var styled_components_1 = __importStar(require("styled-components"));

var settings_1 = require("../../settings");

exports.Input = styled_components_1.default.input(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  ", "\n"], ["\n  ", "\n"])), function (_a) {
  var error = _a.error,
      icon = _a.icon,
      disabled = _a.disabled;
  return (0, styled_components_1.css)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    width: 100%;\n    box-sizing: border-box;\n    border: 1px solid\n      ", ";\n    font-size: 1rem;\n    padding: 1rem 1rem 1rem ", ";\n    outline: none;\n\n    background-size: 2rem;\n    background-repeat: no-repeat;\n    background-position: left 1rem center;\n    background-image: ", ";\n    background-color: ", ";\n    color: ", ";\n\n    &:focus {\n      border: 1px solid ", ";\n    }\n  "], ["\n    width: 100%;\n    box-sizing: border-box;\n    border: 1px solid\n      ", ";\n    font-size: 1rem;\n    padding: 1rem 1rem 1rem ", ";\n    outline: none;\n\n    background-size: 2rem;\n    background-repeat: no-repeat;\n    background-position: left 1rem center;\n    background-image: ", ";\n    background-color: ", ";\n    color: ", ";\n\n    &:focus {\n      border: 1px solid ", ";\n    }\n  "])), error ? settings_1.settings.colours.error : settings_1.settings.colours.border, icon ? '4rem' : '1rem', icon ? "url(".concat(icon, ")") : 'none', disabled ? settings_1.settings.colours.backgroundDisabled : settings_1.settings.colours.background, disabled ? settings_1.settings.colours.textDisabled : settings_1.settings.colours.text, settings_1.settings.colours.selected);
});
exports.ToggleableInputFieldContainer = styled_components_1.default.div(function (_a) {
  var open = _a.open;
  return (0, styled_components_1.css)(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n      display: grid;\n      grid-template-columns: 1fr max-content;\n      width: 100%;\n\n      input {\n        display: ", ";\n      }\n\n      button {\n        align-self: flex-end;\n        margin-left: 0.5rem;\n        height: 66px;\n      }\n    "], ["\n      display: grid;\n      grid-template-columns: 1fr max-content;\n      width: 100%;\n\n      input {\n        display: ", ";\n      }\n\n      button {\n        align-self: flex-end;\n        margin-left: 0.5rem;\n        height: 66px;\n      }\n    "])), open ? 'grid' : 'none');
});
exports.InputFieldContainer = styled_components_1.default.div(function (_a) {
  var hide = _a.hide;
  return (0, styled_components_1.css)(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n    transition: max-height 180ms ease-out;\n    display: flex;\n    flex-direction: column;\n    overflow: hidden;\n    max-height: ", "px;\n  "], ["\n    transition: max-height 180ms ease-out;\n    display: flex;\n    flex-direction: column;\n    overflow: hidden;\n    max-height: ", "px;\n  "])), hide ? 0 : 120);
});
var templateObject_1, templateObject_2, templateObject_3, templateObject_4;